import http from './api'

const route = 'app/comercial6/'

export default {
  showDadosFaturamento: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, classificacao) => {
    return http.post(route + 'showDadosFaturamento', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosDevolucaoImpropria: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, classificacao) => {
    return http.post(route + 'showDadosDevolucaoImpropria', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosBrindes: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, classificacao) => {
    return http.post(route + 'showDadosBrindes', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosMargem: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, classificacao) => {
    return http.post(route + 'showDadosMargem', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },

  showDadosMeta: (dataInicio, dataFim, select, supervisor, receita, tokenContrato, vendedores, rede, categoria, promotor, classificacao) => {
    return http.post(route + 'showDadosMeta', {
      dataInicio: dataInicio,
      dataFim: dataFim,
      select: select,
      supervisor: supervisor,
      vendedores: vendedores,
      receita: receita,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
      classificacao: classificacao,
      tokenContrato: tokenContrato,
    })
  },
}
